import React from "react";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { TOP_BANNER_MWEB } from "../../helpers/brazePlacementIds";
import BrazeBannerSlot from "../Braze/BrazeBannerSlot";
import styles from "./TopBrazeBannerMobile.module.scss";

/** Full-width top banner at the very top of the mobile header (all pages, including cart). */
const TopBrazeBannerMobile: React.FC = () => {
  const isMobile = useCheckMobileScreen();

  if (!isMobile) return null;

  return (
    <BrazeBannerSlot
      placementId={TOP_BANNER_MWEB}
      logLabel="TopBrazeBannerMobile"
      className={styles.topBannerMobileSlot}
      ariaLabel="Promotional top banner"
      animateHeight
      keepMounted
    />
  );
};

export default TopBrazeBannerMobile;
